<template>
    <div class="footer" :class="{darkMode}">
        <div class="version">
            Client: {{ appVersion }} ({{ gitCommitHash }}) |
            Server: {{ apiVersion }}, {{ api }}
        </div>
        <div class="links">
            <router-link to="/terms-and-conditions">{{ $t("footer.tandc") }}</router-link>
            <router-link to="/privacy-policy">{{ $t("footer.privacyPolicy") }}</router-link>
            <a href="https://www.dentwireless.com/company" target="_blank">{{ $t("footer.teamVision") }}</a>
            <span>© DENT Wireless LTD {{ currentYear }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import TDSDate from "@/util/TDSDate";

@Component
export default class DefaultFooter extends Vue {
    @Prop({type: Boolean, default: false}) darkMode!: boolean;

    get appVersion(): string {
        return process.env.VUE_APP_VERSION + "";
    }

    get gitCommitHash(): string {
        return process.env.VUE_APP_GIT_COMMIT_HASH + "";
    }

    get api(): string {
        return (process.env.VUE_APP_API_URL + "")
            .substring(8)
            .split("/")[0];
    }

    get apiVersion(): string {
        return this.$store.state.apiVersion;
    }

    get currentYear(): string {
        return new TDSDate().format("YYYY");
    }

    created() {
        this.$store.dispatch("FETCH_API_VERSION");
    }
}
</script>

<style lang="scss" scoped>
.footer {
    height: $defaultFooterHeight;
    line-height: $defaultFooterHeight;
    @include fontCaption();
    color: $greyShade4;
    text-transform: none;
    text-align: center;
    display: flex;
    justify-content: space-between;

    a,
    a:focus,
    a:visited,
    a:active {
        color: $greyShade4;
        margin-right: 16px;
    }

    a:hover {
        color: $fullGrey;
    }

    &.darkMode {
        a:hover {
            color: white;
        }
    }
}

@media only screen and (max-width: $breakPoint - 1px) {
    .footer {
        flex-direction: column;

        .version {
            order: 2;
        }

        .links {
            order: 1;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 16px;

            a:last-of-type {
                margin: 0;
            }

            span {
                margin-top: 8px;
            }
        }
    }
}
</style>
